<template>
  <div>
    <div class="card">
      <div class="card-header border-bottom">
        <div></div>
        <div class="card-toolbar">
          <div class="d-flex align-items-center gap-2 gap-lg-3">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="secondary" class="btn-icon"
              :to="{ name: 'bPendalamanRegister' }">
              <feather-icon icon="CornerUpLeftIcon" />
            </b-button>
          </div>
        </div>
      </div>
      <div class="card-body pt-1">
        <div ref="formDataRegisterRef">
          <div class="border border-1 rounded p-1 mx-25 mb-2" style="min-height: 50vh;">
            <div class="text-center mb-1">
              <h4 class="font-weight-bolder text-muted text-uppercase">Data Register BMD</h4>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Guid ID</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.guid_aset || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Register</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.noreg_108 || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Kode Barang</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.kobar_108 || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nama Barang</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nabar_108 || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Tanggal Perolehan</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.tgl_oleh || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Harga Perolehan</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.harga_oleh || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Bahan</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.bahan || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Merk</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.merk || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Tipe</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.tipe || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Chasis</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nochasis || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Mesin</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nomesin || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Polisi</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nopol || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor BPKB</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nobpkb || '-' }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col-12">
            <span class="text-muted text-uppercase font-medium-1 font-weight-bold">Form Pendalaman Register </span>
          </div>
        </div>
        <div class="p-1 mx-25 mb-2" style="min-height: 10vh;">
          <validation-observer ref="simpleRules">
            <div class="row mb-2">
              <span class="col-12 font-weight-bold font-small-5">Permasalahan BMD <span
                  class="text-danger">*</span></span>
              <div class="col-12 mt-50">
                <validation-provider #default="{ errors }" name="Permasalahan BMD" rules="required">
                  <div class="d-flex flex-row mt-50 mt-md-0" style="gap:10px">
                    <b-form-radio v-model="formDatas.jenis_pendalaman" value="biaya-biaya">
                      Merupakan Biaya Biaya
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.jenis_pendalaman" value="fisik-tidak-ditemukan">
                      Fisik Tidak Ditemukan
                    </b-form-radio>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
            <div>
              <div v-if="formDatas.jenis_pendalaman == 'biaya-biaya'">
                <formDatasA :fD="formDatas.biaya_biaya" :bmd="formDatas.data_register" />
              </div>
              <div v-else-if="formDatas.jenis_pendalaman == 'fisik-tidak-ditemukan'">
                <formDatasB :fD="formDatas.fisik_tidak_ditemukan" :bmd="formDatas.data_register" />
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end pe-5 ps-5 gap-2">
        <b-button v-if="Object.keys(formDatas.data_register).length > 0" variant="primary" @click="submitForm">
          Simpan
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import pendalamanRegister from "@/composables/b/pendalamanRegister";
import { id as localeId } from "vee-validate/dist/locale/id";
import { showNotifikasi } from '@/libs/helper';
import ModalLookupRegisterBdm from './components/ModalLookupRegisterBdm';
import FormDatasA from './components/FormDatasA.vue'
import FormDatasB from './components/FormDatasB.vue'

export default {
  setup(props, context) {
    const g = context.root;
    const hasil_sensus_bmd_id = g.$route.params.id;
    /* IMPPORTANT FORM DATA HARUS DI DEFINE DULU */
    const formDatas = ref({
      jenis_pendalaman: null,
      data_register: {},
      biaya_biaya: {},
      fisik_tidak_ditemukan: {}
    });
    const modalData = ref({
      show: false,
      data: null,
    });
    const openLookupRegisterBmd = () => {
      modalData.value.show = true;
    };
    const formDataRegisterRef = ref(null);
    const confirmLookupRegisterBmdDialog = (data) => {
      modalData.value.show = false;
      formDatas.value.tahun = data.tahun;
      formDatas.value.kolok = data.kolok;
      formDatas.value.data_register = { register_b_id: data.id, ...data };
      delete formDatas.value.data_register.id;
      formDataRegisterRef.value.scrollIntoView({ behavior: 'smooth' });

    };
    const closeLookupRegisterBmdDialog = (item) => {
      modalData.value.show = false;
    };

    /* FORM */
    const isLoadGetData = ref(false);
    const getData = () => {
      isLoadGetData.value = true;
      let params = {
        filter_platform: 'web',
        filter_kategori: 'tercatat',
        hasil_sensus_bmd_id: hasil_sensus_bmd_id,
      };
      pendalamanRegister.getDetailPendalamanRegister(g, params).then(res => {
        formDatas.value = res.data;
        isLoadGetData.value = false;
      }).catch(err => {
        isLoadGetData.value = false;
        console.log(err)
      });

    };
    getData();

    const submitForm = () => {
      let payload = formDatas.value;
      context.refs.simpleRules.validate().then(async success => {
        if (success) {
          pendalamanRegister.submitPengajuan(g, payload).then(resp => {
            if (resp.success) {
              showNotifikasi(g, 'success', 'Success', resp.message)
              g.$router.push({ name: 'bPendalamanRegister' })
            } else {
              showNotifikasi(g, 'danger', 'Error', resp.message)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      });
    };



    return {
      formDataRegisterRef,
      formDatas,
      openLookupRegisterBmd,
      closeLookupRegisterBmdDialog,
      confirmLookupRegisterBmdDialog,
      modalData,

      submitForm,
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ModalLookupRegisterBdm,
    FormDatasA,
    FormDatasB
  },
  data() {
    return {
      required,
    }
  },
  directives: {
    Ripple,
  },
  props: {
    page: String,
  },
};
</script>
